import area from "@turf/area";
import length from "@turf/length";
import { Divider, Select } from "antd";
import { useState } from "react";
import { decimalToDMS } from "./ultis";



const PolygonInfo = (props: any) =>
{
  const [format, setFormat] = useState("lat, lng minutes");

  // A Point AOI (e.g. Satellogic orders) has no area/perimeter and its
  // coordinates are a flat [lng, lat] pair rather than a ring — turf's
  // area()/length() and the coordinate-ring listing below only apply to
  // Polygon geometry.
  const isPoint = props?.selectedPolygon?.type === "Point";

  const outArea = props?.selectedPolygon && !isPoint ? area(props?.selectedPolygon) : 0;
  const perimeter = props?.selectedPolygon && !isPoint ? length(props?.selectedPolygon, { units: "kilometers" }) : 0;

  let output;
  if (outArea > 10000)
  {
    output = Math.round((outArea / 1000000) * 100) / 100 + " km²";
  } else
  {
    output = Math.round(outArea * 100) / 100 + " m²";
  }

  const handleFormatChange = (value: string) =>
  {
    setFormat(value);
  };

  const convertCoordinates = (item: any) =>
  {
    if (format === "lat, lng degrees")
    {
      return `${item?.[0]}, ${item?.[1]}`; // Định dạng thập phân
    } else
    {
      const latitudeDMS = decimalToDMS(item?.[1], "N", "S");
      const longitudeDMS = decimalToDMS(item?.[0], "E", "W");
      return `${longitudeDMS}, ${latitudeDMS}`; // Định dạng độ phút giây
    }
  };

  // console.log(props?.selectedPolygon?.geometry?.coordinates, 'props?.selectedPolygon?.geometry?.coordinates');

  return (
    <div className="text-[var(--color-label-form)]">
      <div className="flex gap-2 justify-between items-center">
        <p className="text-[var(--color-text-title-cardListItem)]">{props?.t("Format")}</p>
        <Select
          className="mb-2  rounded div-dropdown"
          defaultValue="lat, lng minutes"
          onChange={handleFormatChange}
          style={{ width: 200 }}
          options={[
            { value: "lat, lng degrees", label: "lat, lng degrees" },
            { value: "lat, lng minutes", label: "lat, lng minutes" },
          ]}
        />
      </div>
      <Divider style={{ margin: "10px 0" }} />
      {!isPoint && (
        <>
          <div key={"Area"} className="flex justify-between py-1">
            <p className="mb-1 text-des">{props?.t("Area")}</p>
            <span className="text-[var(--color-text-title-cardListItem)]">{output}</span>
          </div>
          <div key={"Perimeter"} className="flex justify-between py-1">
            <p className="mb-1 text-des">{props?.t("Perimeter")}</p>
            <span className="text-[var(--color-text-title-cardListItem)]">{Math.round(perimeter * 100) / 100} km</span>
          </div>
        </>
      )}
      {isPoint ? (
        <div key={"Coordinate"} className="flex justify-between py-1">
          <p className="mb-1 text-des">{props?.t("Coordinate")}</p>
          <span className="text-[var(--color-text-title-cardListItem)]">
            {convertCoordinates(props?.selectedPolygon?.coordinates)}
          </span>
        </div>
      ) : (
        props?.selectedPolygon?.coordinates?.[0]?.map(
          (item: any, index: any) =>
          {
            const val = convertCoordinates(item);
            return (
              <div key={index} className="flex justify-between py-1 ">
                <p className="mb-1 text-des">
                  {props?.t("Coordinate")} {index + 1}
                </p>
                <span className="text-[var(--color-text-title-cardListItem)]">{val}</span>
              </div>
            );
          }
        )
      )}

    </div>
  );
};

export default PolygonInfo;
